import { Carousel } from '@nextgen-web-framework/all';
import type HeroBannerProps from '../heroBanner/types/propsTypes';
import HeroComponentItem from './HeroComponentItem';
import styles from './HeroBanner.module.scss';
const HeroBanner = (props: HeroBannerProps) => {
  if (props?.images?.length === 1) {
    const [bannerImage] = props.images;
    return <HeroComponentItem {...bannerImage} />;
  }
  return (
    <div className={styles['hero-banner-carousel-container']}>
      <Carousel hideButtons={false} id={'Hero-Banner-Carousel'} isTileCarousel={false}>
        {props?.images?.map((bannerImage) => (
          <HeroComponentItem key={`${bannerImage.title}${bannerImage.subTitle}`} {...bannerImage} />
        ))}
      </Carousel>
    </div>
  );
};

export default HeroBanner;
